export const SRP_CARD_WIDTH = '21rem'